import type { DocMigration } from "../docMigration";

const LEGACY_EYEBROW_TRIM_MATERIAL = "headCasing0";

interface ExteriorCasingJson {
  headCasingType?: string;
  material?: string;
}

interface ExteriorCasingOwnerJson {
  exteriorCasing?: ExteriorCasingJson;
}

interface SettingsJson extends ExteriorCasingJson {
  type?: string;
  doorTypes?: Record<string, ExteriorCasingOwnerJson>;
  windowTypes?: Record<string, ExteriorCasingOwnerJson>;
}

interface MigrationDocJson {
  openings?: Record<string, ExteriorCasingOwnerJson>;
  settings?: Record<string, SettingsJson>;
}

function preserveEyebrowTrimMaterial(casing: ExteriorCasingJson | undefined): void {
  if (casing?.headCasingType === "EYEBROW_TRIM") {
    casing.material = LEGACY_EYEBROW_TRIM_MATERIAL;
  }
}

function migrateDoc(doc: MigrationDocJson): void {
  for (const opening of Object.values(doc.openings ?? {})) {
    preserveEyebrowTrimMaterial(opening.exteriorCasing);
  }

  for (const settings of Object.values(doc.settings ?? {})) {
    if (settings.type === "EXTERIOR_DOOR_CASING_SETTINGS" || settings.type === "EXTERIOR_WINDOW_CASING_SETTINGS") {
      preserveEyebrowTrimMaterial(settings);
    }
    if (settings.type === "DOOR_CATALOG_SETTINGS") {
      for (const door of Object.values(settings.doorTypes ?? {})) {
        preserveEyebrowTrimMaterial(door.exteriorCasing);
      }
    }
    if (settings.type === "WINDOW_CATALOG_SETTINGS") {
      for (const window of Object.values(settings.windowTypes ?? {})) {
        preserveEyebrowTrimMaterial(window.exteriorCasing);
      }
    }
  }
}

const migration: DocMigration = {
  id: "20260824_preserve_eyebrow_trim_material",
  description: "Preserve the legacy material for existing eyebrow trim",
  apply(json) {
    migrateDoc(json as MigrationDocJson);
    return json;
  },
};

export default migration;
